import { fetchToken } from "../../common/FetchCookie";
import {
  BASE_URL,
  CANDIDATE,
  CANDIDATE_BASIC_DETAILS,
  CANDIDATE_BASIC_DETAILS_PARAM,
  CANDIDATE_CERTIFICATION_PARAM,
  CANDIDATE_CURRENT_COMPANY_PARAM,
  CANDIDATE_DETAILS_BY_PARAM,
  CANDIDATE_EDUCATION_PARAM,
  CANDIDATE_EMPLOYMENT_PARAM,
  CANDIDATE_ITSKILLS_PARAM,
  CANDIDATE_LANGUAGES_PARAM,
  CANDIDATE_PROFILE_PHOTO,
  CANDIDATE_PROJECTS_PARAM,
  CANDIDATE_RESUME,
} from "../../common/URLs";

export const fetchBasicDetails = async () => {
  try {
    const token = await fetchToken();
    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_BASIC_DETAILS_PARAM}&${CANDIDATE_CURRENT_COMPANY_PARAM}&${CANDIDATE_EDUCATION_PARAM}&${CANDIDATE_CERTIFICATION_PARAM}&${CANDIDATE_EMPLOYMENT_PARAM}&${CANDIDATE_ITSKILLS_PARAM}&${CANDIDATE_LANGUAGES_PARAM}&${CANDIDATE_PROJECTS_PARAM}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "application/json",
        },
      }
    );
    const data = await response.json();
    // console.log("data:- ", data)
    return data.response;
  } catch (error) {
    console.log("error in making fetching the  basic details ", error);
  }
};

const API_URL = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_BASIC_DETAILS}`;

export const updateCandidateDetails = async (uuid, candidateData) => {
  try {
    const token = await fetchToken();
    const response = await fetch(`${API_URL}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(candidateData),
    });
    // console.log("cand", candidateData);

    if (!response.ok) {
      throw new Error("Error updating candidate : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating candidate : " + error.message);
  }
};

// api.js (API Call)

export const addCandidateProfile = async (formData) => {
  try {
    // console.log("api call", formData)
    const token = await fetchToken();
    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_PROFILE_PHOTO}`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to upload logo");
    }

    const data = await response.json();
    return data; // Return the uploaded logo data (e.g., URL, ID, etc.)
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addCandidateResume = async (formData) => {
  try {
    // console.log("api call", formData)
    const token = await fetchToken();
    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_RESUME}`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to upload logo");
    }

    const data = await response.json();
    return data; // Return the uploaded logo data (e.g., URL, ID, etc.)
  } catch (error) {
    throw new Error(error.message);
  }
};







// import { fetchToken } from "../../common/FetchCookie";
// import {
//   BASE_URL,
//   CANDIDATE,
//   CANDIDATE_BASIC_DETAILS,
//   CANDIDATE_BASIC_DETAILS_PARAM,
//   CANDIDATE_CERTIFICATION_PARAM,
//   CANDIDATE_CURRENT_COMPANY_PARAM,
//   CANDIDATE_DETAILS_BY_PARAM,
//   CANDIDATE_EDUCATION_PARAM,
//   CANDIDATE_EMPLOYMENT_PARAM,
//   CANDIDATE_ITSKILLS_PARAM,
//   CANDIDATE_LANGUAGES_PARAM,
//   CANDIDATE_PROFILE_PHOTO,
//   CANDIDATE_PROJECTS_PARAM,
//   CANDIDATE_RESUME,
// } from "../../common/URLs";

// // Cache for basic details
// const basicDetailsCache = {
//   data: null,
//   timestamp: 0,
//   ttl: 300000, // 5 minutes cache
// };

// export const fetchBasicDetails = async () => {
//   try {
//     // Check cache first
//     const now = Date.now();
//     if (basicDetailsCache.data && now - basicDetailsCache.timestamp < basicDetailsCache.ttl) {
//       return basicDetailsCache.data;
//     }

//     const token = await fetchToken();
//     const response = await fetch(
//       `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_BASIC_DETAILS_PARAM}&${CANDIDATE_CURRENT_COMPANY_PARAM}&${CANDIDATE_EDUCATION_PARAM}&${CANDIDATE_CERTIFICATION_PARAM}&${CANDIDATE_EMPLOYMENT_PARAM}&${CANDIDATE_ITSKILLS_PARAM}&${CANDIDATE_LANGUAGES_PARAM}&${CANDIDATE_PROJECTS_PARAM}`,
//       {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           accept: "application/json",
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }

//     const data = await response.json();

//     // Update cache
//     basicDetailsCache.data = data.response;
//     basicDetailsCache.timestamp = now;

//     return data.response;
//   } catch (error) {
//     console.error("Error fetching basic details:", error);
//     // Return cached data if available, even if stale
//     return basicDetailsCache.data || null;
//   }
// };

// const API_URL = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_BASIC_DETAILS}`;

// // Debounce function to prevent rapid successive updates
// const debounce = (func, delay) => {
//   let timeoutId;
//   return function (...args) {
//     clearTimeout(timeoutId);
//     timeoutId = setTimeout(() => func.apply(this, args), delay);
//   };
// };

// const updateCandidateDetailsDebounced = debounce(async (uuid, candidateData, token) => {
//   const response = await fetch(`${API_URL}/${uuid}`, {
//     method: "PUT",
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//     body: JSON.stringify(candidateData),
//   });

//   if (!response.ok) {
//     throw new Error("Error updating candidate: " + response.statusText);
//   }

//   return await response.json();
// }, 500); // 500ms debounce delay

// export const updateCandidateDetails = async (uuid, candidateData) => {
//   try {
//     const token = await fetchToken();
//     return await updateCandidateDetailsDebounced(uuid, candidateData, token);
//   } catch (error) {
//     throw new Error("Error updating candidate: " + error.message);
//   }
// };

// // File upload functions with retry logic
// const uploadWithRetry = async (url, formData, token, retries = 3) => {
//   for (let i = 0; i < retries; i++) {
//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         body: formData,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       return await response.json();
//     } catch (error) {
//       if (i === retries - 1) throw error;
//       // Wait before retrying (exponential backoff)
//       await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
//     }
//   }
// };

// export const addCandidateProfile = async (formData) => {
//   try {
//     const token = await fetchToken();
//     return await uploadWithRetry(
//       `${BASE_URL}/${CANDIDATE}/${CANDIDATE_PROFILE_PHOTO}`,
//       formData,
//       token
//     );
//   } catch (error) {
//     throw new Error("Failed to upload profile: " + error.message);
//   }
// };

// export const addCandidateResume = async (formData) => {
//   try {
//     const token = await fetchToken();
//     return await uploadWithRetry(
//       `${BASE_URL}/${CANDIDATE}/${CANDIDATE_RESUME}`,
//       formData,
//       token
//     );
//   } catch (error) {
//     throw new Error("Failed to upload resume: " + error.message);
//   }
// };